import { Quote } from "lucide-react";
import { TESTIMONIALS, STATS } from "@/lib/site";

export const SocialProof = () => {
  return (
    <section className="bg-[var(--bg)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="eyebrow">Tenant voices</div>
            <h2 className="section-title text-[44px] md:text-[58px] mt-4 leading-[1.02]">
              The reason most of our tenants <em className="italic text-[var(--primary)]">stay.</em>
            </h2>
            <div className="mt-12 grid grid-cols-2 gap-6">
              {STATS.map((s) => (
                <div key={s.label} className="hairline bg-white p-6">
                  <div className="font-serif text-[42px] text-[var(--primary)] leading-none">{s.value}</div>
                  <div className="text-[12px] mt-3 uppercase tracking-[0.16em] text-[var(--text-muted)]">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-7 space-y-5">
            {TESTIMONIALS.map((t, i) => (
              <figure key={i} className="hairline bg-white p-8 md:p-10">
                <Quote size={22} strokeWidth={1.3} className="text-[var(--secondary)]" />
                <blockquote className="font-serif text-[24px] md:text-[28px] leading-[1.25] tracking-tight mt-5 text-[var(--text-main)]">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3 text-[13px]">
                  <span className="w-8 h-px bg-[var(--secondary)]" />
                  <span className="text-[var(--text-main)] font-medium">{t.author}</span>
                  <span className="text-[var(--text-muted)]">· {t.role}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
